import React, { Component, Fragment } from 'react';

import { Icon } from 'semantic-ui-react';

import Media from 'react-media';

class ResearchItem extends Component {
    render() {

        const figure = this.props.research.image;
        
        return (
            <div style={researchBoxStyle}>
                <React.Fragment>
                <div style={greenBand} />
                <div style={researchMainBox}>
                    <h1 style={researchHeaderStyle}>{ this.props.research.title }</h1>
                    <div style={horizontalDivider} />
                    <Media queries={{
                        narrow: "(max-width: 1178px)",
                        wide: "(min-width: 1179px)"
                    }}>
                    { matches => (
                            <Fragment>
                                {matches.narrow && 
                                <Fragment>

        <div style={researchSubBoxNarrow} >
            <div style={topBoxStyle}>
                <img src={require(`../../images/${this.props.research.image}`)} alt='Research' style={figureImageStyle} />
                <div style={authorsBoxNarrow}>
                    <p style={authorsStyle}>{ this.props.research.authors }</p>
                </div>
                <div style={horizontalDivider} />
            </div>
            <div style={bottomBoxStyle}>
                {this.props.research.text}
                <div style={linkStyleNarrow}>
                    <a href={require("../../files/" + this.props.research.link + ".pdf")} target="_blank">
                    
                        <p style={linkTextStyleNarrow}>View Paper
                            <Icon name='angle right' style={iconStyle} />
                        </p>
                    </a>           
                </div> 
            </div>
        </div>                             


                                </Fragment>}
                                {matches.wide &&
                                <Fragment>


        <div style={researchSubBox} >
            <div style={leftBoxStyle}>
                {this.props.research.text}
            </div>
            <div style={rightBoxStyle}>
                <img src={require(`../../images/${this.props.research.image}`)} alt='Research' style={figureImageStyle} />
                <div style={authorsBox}>
                    <p style={authorsStyle}>{ this.props.research.authors }</p>
                    <div style={horizontalDivider} />
                </div>

                <a href={require("../../files/" + this.props.research.link + ".pdf")} target="_blank">
                    <div style={linkStyle}>
                        <p style={linkTextStyle}>View Paper
                        <Icon name='angle right' style={iconStyle} />
                        </p>
                    </div>                
                </a>
            </div>
        </div> 


                                </Fragment>}
                                </Fragment>
                            )}
                    </Media>       
                </div> 
                </React.Fragment>
            </div>
        )
    }
}

const researchBoxStyle = {
    maxWidth: '880px',
    marginLeft: 'auto',
    marginRight: 'auto',
    marginBottom: '40px',
    borderRadius: '8px',
    backgroundColor: '#f2f2f2',
    boxShadow: '0px 10px 6px #e3e3e3',
    display: 'flex',
    flexAlign: 'row',
    overflow: 'hidden',
}

const greenBand = {
    width: '30px',
    display: 'tableCell',
    backgroundColor: '#b6c97b',
    flexShrink: '0',
}

const researchMainBox = {
    padding: '12px 10px 12px 10px',
    flexShrink: '1',
}

const researchHeaderStyle = {

}

const horizontalDivider = {
    width: '80%',
    height: '2px',
    margin: '10px auto 0px auto',
    backgroundColor: '#dbdbdb',
    order: '2'
}

const researchSubBox = {
    display: 'flex',
    flexFlow: 'row nowrap',
}

const researchSubBoxNarrow = {
    display: 'flex',
    flexFlow: 'column wrap',
}

const leftBoxStyle = {
    maxWidth: '460px',
    margin: '10px 0px 10px 10px',
    padding: '10px 10px 10px 10px',
    textAlign: 'justify',
    fontFamily: 'Source Serif Pro, sans-serif',
    fontSize: '18px',
    flexShrink: '1'
}

const bottomBoxStyle = {
    maxWidth: '100%',
    margin: '10px 0px 10px 10px',
    padding: '10px 10px 10px 10px',
    textAlign: 'justify',
    fontFamily: 'Source Serif Pro, sans-serif',
    fontSize: '18px',
}

const rightBoxStyle = {
    height: '100%',
    maxWidth: '100%',
    margin: '26px 20px 10px 20px',
    display: 'flex',
    flexFlow: 'column nowrap',
    flexShrink: '1'
}

const topBoxStyle = {
    maxWidth: '100%',
    margin: '26px 20px 10px 20px',
    display: 'flex',
    flexFlow: 'column nowrap',
}

const figureImageStyle = {
    position: 'relative',
    maxWidth: '100%',
    borderRadius: '8px',
    flexShrink: '2'
}

const authorsBox = {
    maxWidth: '360px',
    minWidth: '200px',
}

const authorsBoxNarrow = {
    maxWidth: '100%',
    minWidth: '200px',
    marginTop: '10px'
}

const authorsStyle = {
    color: '#808080',
    textAlign: 'center',
    marginTop: '4px',
    marginLeft: '4px',
    fontFamily: 'Source Serif Pro, sans-serif',
    fontSize: '18px',
    fontStyle: 'italic'
}

const linkStyle = {
    display: 'flex',
    flexFlow: 'row wrap',
    fontFamily: 'Heebo, sans-serif',
    fontSize: '18px',
    textAlign: 'center'
}

const linkStyleNarrow = {
    marginTop: '40px',
    marginLeft: '4px',
    fontFamily: 'Heebo, sans-serif',
    fontSize: '18px',
    float: 'right'
}

const linkTextStyle = {
    margin: '10px auto'
}

const linkTextStyleNarrow = {
    float: 'center',
}

const iconStyle = {

}

export default ResearchItem;